"use client";

import { useRouter } from "@i18n/next";
import { useRequestMe, useSession } from "@packages/sdk";
import { useIsDesktopViewport } from "@packages/ui";
import { useEffect } from "react";

export const MobileRedirect = () => {
  const isDesktop = useIsDesktopViewport();
  const {
    query: { data: me },
  } = useRequestMe();
  const router = useRouter();
  const { status } = useSession();

  useEffect(() => {
    if (isDesktop && me?.is_kid) return router.replace("/settings/legal");

    if (isDesktop && status !== "loading") {
      if (status === "authenticated")
        router.replace("/settings/account/profile");
      else router.replace("/settings/language");
    }
  }, [isDesktop, me, status]);

  return <></>;
};
